export const Errors: { [key: string]: string } = {
  'each value in emails must be an email': 'One or more email addresses are invalid!',
  'partnerId must be a UUID': 'Trading partner is required!',
};
